export const state = {
  bazaarvoiceUrl: '',
};

export const mutations = {
  setBazaarVoiceUrl(state, payload) {
    state.bazaarvoiceUrl = payload;
  },
};

export const actions = {
  setBazaarVoiceUrl({ commit }, payload) {
    commit('setBazaarVoiceUrl', payload);
  },
};
export const getters = {
  getBazaarvoiceUrl: (state) => state.bazaarvoiceUrl,
};

export default  {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
